import API from "./axios";

export const VVVSignUp = async (userDetail) => {
  try {
    const response = await API.post("Application/Register", userDetail, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return {
      success: true,
      message:
        response.data?.message ||
        "You will receive an email update regarding your application once it has been reviewed by our team.",
      id: response.data?.id,
    };
  } catch (error) {
    console.error("Sign-up error:", error);

    const errorMessage =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      (error.request
        ? "No response from the server. Please check your internet connection."
        : "An unexpected error occurred. Please try again.");

    return { success: false, message: errorMessage };
  }
};

export const VVVClipSubmission = async (userDetail) => {
  try {
    const response = await API.post("ClipSubmissions/Submit", userDetail, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return {
      success: true,
      message:
        response.data?.message ||
        "You will receive an email update regarding your clip submission once it has been reviewed by our team.",
      id: response.data?.id,
    };
  } catch (error) {
    console.error("Submission error:", error);

    const errorMessage =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      (error.request
        ? "No response from the server. Please check your internet connection."
        : "An unexpected error occurred. Please try again.");

    return { success: false, message: errorMessage };
  }
};
